import { createStore } from 'vuex'

export default createStore({
  state: {
    // 사용자 ID 처리 개선:
    // 1. 초기 사용자 정보를 'Err'로 설정하여 로그인되지 않거나 정보 로드 실패 시 명확히 인지하도록 함.
    // 2. decodeM API 호출 실패 시 기존 정보 유지 대신 'Err'로 즉시 설정되도록 HomeView.vue 수정.
    // 3. 소감 저장/수정 시 사용자 ID 유효성 검사 및 본인 확인 절차 추가 (SogamWriteView.vue).
    // 4. 소감 리스트 조회 시 사용자 ID가 'Err'일 경우 조회 차단 (SogamListView.vue, PastorSogamListView.vue).
    userName: 'Err',
    userId: 'Err',
    userMemId: 'Err',
    userCell: 'Err',
    userTeam: 'Err',

    isChristMasSeason: false,
    isXmasAdmin: false,
    judgeYn: 'N',
    concertCd: '',
    concertNm: '',
    partCd: '',
    partNm: '',

    searchTitle: '',
    searchCell: '',
    searchName: '',
    searchUseChk: false,
    searchConfirm: false,
    searchOrderCond: 1
  },
  getters: {},
  mutations: {
    setUserName(state, payload) {
      state.userName = payload
    },
    setJudgeYn(state, payload) {
      state.judgeYn = payload
    }
  },
  actions: {},
  modules: {}
})
